import BasePointManager from "../../../../../../src/managers/BasePointManager";
import { Coord, RedPointRadianInfo } from "../../../../../../src/types/Interface";
import { CIRCLE_RADIUS, INITIAL_INTERSEC_RADIUS, INITIAL_RADIANS } from "../../types/Config";
import { eventBus, EnumEventBus } from "../EventBus";
import { findIntersecCoord, generateChordPoints } from "./helpers/pointHelpers";


export default class PointManager extends BasePointManager {
	private intersecLA = INITIAL_INTERSEC_RADIUS;
	private intersecLB = INITIAL_INTERSEC_RADIUS;
	private intersecCoord = { x: 100, y: 100 };
	private chordACoords: Coord[];
	private chordBCoords: Coord[];
	private pointCheckList: Boolean[] = [];
	private tags: string[] = [];


	constructor(cCoord: Coord) {
		super(cCoord, CIRCLE_RADIUS, INITIAL_RADIANS)
		this.setCoord();
		this.draw();

		this.chordACoords = this.genChordCoords( this.pointRadians[0], this.intersecLA);
		this.chordBCoords = this.genChordCoords(this.pointRadians[1], this.intersecLB);
		this.intersecCoord = findIntersecCoord([this.chordACoords[0], this.chordACoords[2], this.chordBCoords[0], this.chordBCoords[2]]);
		this.tags = this.getRedPoints().map(p => p.tag);

		eventBus.on(EnumEventBus.setPointChecklist, l => this.pointCheckList = l);
		eventBus.on(EnumEventBus.rotateChords, (v: number) => this.handleRotateChords(v));
		eventBus.on(EnumEventBus.moveChordA, (v: number) => this.handleMoveChordA(v));
		eventBus.on(EnumEventBus.moveChordB, (v: number) => this.handleMoveChordB(v));
	}
	genChordCoords = (rad:number,intersec:number) => generateChordPoints(this.cCoord, CIRCLE_RADIUS, rad, intersec);
	getInitialIntersecCoord = (initialCoords:Coord[][]) => findIntersecCoord([initialCoords[0][0], initialCoords[0][2], initialCoords[1][0], initialCoords[1][2]])
	getInitialChordsCoords = () => [
		this.genChordCoords(INITIAL_RADIANS[0], INITIAL_INTERSEC_RADIUS),
		this.genChordCoords(INITIAL_RADIANS[1], INITIAL_INTERSEC_RADIUS),
	]
	getChordsCoords = () => [this.chordACoords, this.chordBCoords];
	getIntersecCoord = () => this.intersecCoord;
	
	setRadian(pointInfoArr: RedPointRadianInfo[], isSlider?: boolean): void {
		pointInfoArr.forEach(pointInfo => {
			if (pointInfo.pTag == this.tags[0]) {
				this.chordACoords = generateChordPoints(this.cCoord, CIRCLE_RADIUS, pointInfo.radian, this.intersecLA);
			} else {
				this.chordBCoords = generateChordPoints(this.cCoord, CIRCLE_RADIUS, pointInfo.radian, this.intersecLB);
			}
		})

		this.intersecCoord = findIntersecCoord([this.chordACoords[0], this.chordACoords[2], this.chordBCoords[0], this.chordBCoords[2]]);
		this._setRadian(pointInfoArr, isSlider);
	}

	private handleRotateChords(v: number) {
		const points = this.getRedPoints();
		const radians = this.getRefRadians();
		const generateOffsetRadian = (v: number) => (Math.PI / 300) * v;
		const pointInfoArr = this.pointCheckList
			.map((e, eI) => this.pointRefRadians[eI] + (e ? generateOffsetRadian(v) : 0))
			.map((r, rI) => ({ pTag: points[rI].tag, radian: r }))
			.filter((pointInfo, pII) => pointInfo.radian != radians[pII]);

		this.setRadian(pointInfoArr, true);
	}
	private handleMoveChordA(v: number) {
		this.intersecLA = Math.floor(v * .35 + INITIAL_INTERSEC_RADIUS);
		const pointInfoArr = this.getCurrRedPointInfo(0);
		this.setRadian(pointInfoArr, true);
	}
	private handleMoveChordB(v: number) {
		this.intersecLB = Math.floor(v * .35 + INITIAL_INTERSEC_RADIUS);
		const pointInfoArr = this.getCurrRedPointInfo(1);
		this.setRadian(pointInfoArr, true);
	}
	private getCurrRedPointInfo(index: number) {
		const point = this.RedPointsArr[index];
		const radian = this.pointRadians[index];
		return [{ pTag: point.tag, radian }]
	}
}